import Chip from '../../../shared/components/Chip/Chip';
import { getCalculationStatusLabel, getCalculationStatusTone, getReadinessLabel, getReadinessTone } from '../powerBalanceFormatters';

export default function PowerBalanceStatusCard({ calculation }) {
  const readiness = typeof calculation?.readiness === 'string' ? calculation.readiness : calculation?.readiness?.status;
  return <div className="power-balance-statuses"><div><span>Statut du calcul</span><Chip color={getCalculationStatusTone(calculation?.status)} label={getCalculationStatusLabel(calculation?.status)} /></div><div><span>Préparation</span><Chip color={getReadinessTone(readiness)} label={getReadinessLabel(readiness)} /></div></div>;
}
